import type { AppConfig } from "vue";

interface Logger {
  info: (message: string, ...args: any[]) => void;
  warn: (message: string, ...args: any[]) => void;
  error: (message: string, ...args: any[]) => void;
}

const logger: Logger = {
  info: (message: string, ...args: any[]) => {
    console.log(message, ...args);
  },

  warn: (message: string, ...args: any[]) => {
    console.warn(message, ...args);
  },

  error: (message: string, ...args: any[]) => {
    console.error(message, ...args);
  },
};

/** Logs an error Vue caught in a component, labelled with that component's name. */
export const logComponentError: NonNullable<AppConfig["errorHandler"]> = (
  err,
  instance,
  info
) => {
  // `name` is only set when a component declares one. For <script setup> components the SFC
  // compiler records the name it infers from the filename as `__name`.
  const componentInfo = instance
    ? `in ${instance.$options.name || instance.$options.__name || "anonymous component"}`
    : "";
  logger.error(`Error ${componentInfo}: ${String(err)}\n${info}`);
};

export default logger;
